import axios from "axios";
import { attachAuthInterceptors } from "./attachAuthInterceptors";

const apiMetersClient = axios.create({
    baseURL:process.env.REACT_APP_API_METERS,
    timeout: 30000
    // withCredentials: true
})

attachAuthInterceptors(apiMetersClient);

export default apiMetersClient